import { Button } from "components/Button/Button";
import { Textbox } from "components/Textbox/Textbox";
import { Application } from "components/Application/Application";
import { useEffect, useState } from "react";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { trans } from "utils/helpers";
import { ApplicationWithRoute } from "components/Application/ApplicationWithRoute";

interface CreateFormProps {
    onHide: (e:boolean)=>void;
    handleNewForm: (e:any,data:any)=>void;
    obj?:any;
    mode:'create'|'view'|'edit';
    createGrid?:boolean
}

export const CreateInputForm = ({onHide,handleNewForm,obj,mode,createGrid}:CreateFormProps) => {
    const [applicationIds , setApplicationIds] = useState< any>([])

    const handleSubmit = async(event) => {  
        event.preventDefault()


        let data = {
            DynamicForms:{
                formTitle: event.target.formTitle?.value,
                SystemKey: event.target.SystemKey?.value,
                Id:obj?.Id?obj?.Id: obj?.DynamicForms?.Id,
                FormTitleEN: event.target.FormTitleEN?.value,
                FormPriority:+event.target.FormPriority?.value,
                IsWorkflowEnable:event.target.IsWorkflowEnable?.checked,
                HasSignature:event.target.HasSignature?.checked

            },
            DynamicFormApplications:applicationIds 
           
        }
        handleNewForm(event,data)
    }

    function cancel() {
        onHide(false)    
    }


    return ( 
        <form onSubmit={handleSubmit}>
            <div className="card">
                <div className="card-body row ">
                    <div className="col-4">
                        <Textbox mode={mode} textboxType={'text'} textboxName={'formTitle'} labelText="formTitle" defaultValue={obj?.formTitle?obj?.formTitle:obj?.DynamicForms?.formTitle} required/>
                    </div>
                    <div className="col-4">
                        <Textbox mode={mode} textboxType={'text'} textboxName={'FormTitleEN'} labelText="FormTitleEN" defaultValue={obj?.FormTitleEN?obj?.FormTitleEN:obj?.DynamicForms?.FormTitleEN} required/>
                    </div>
                    <div className="col-4">
                        <Textbox  mode={mode} textboxType={'number'} min={0} textboxName={'FormPriority'} labelText="FormPriority" defaultValue={obj?.FormPriority?obj?.FormPriority:obj?.DynamicForms?.FormPriority} required/>
                    </div>
                  
                    <div className="col-4">
                        <Textbox textboxType={'formKey'} textboxName={'SystemKey'} labelText="SystemKey" defaultValue={obj?.SystemKey?obj?.SystemKey:obj?.DynamicForms?.SystemKey} required mode={mode == 'create' ? 'create' : 'view'}/>
                    </div>
              {!createGrid ?<>     <div className="col-4">
                    <ApplicationWithRoute
                                ApplicationListCallback={(e)=>
                                setApplicationIds(e)
                                }
                                type="SelectBox"
                                mode={mode}
                                required={true}
                                name="ApplicationId"
                      value={
                        obj?.DynamicFormApplications.length>0 ?obj?.DynamicFormApplications :undefined
                      }
                              />

                    </div>
                    <div>
                    <CheckableButton 
                    type="checkbox"
                    mode={mode}
                    defaultChecked={obj?obj?.IsWorkflowEnable:true }
                     defaultValue={obj?obj?.IsWorkflowEnable:true } 
                     labelText={trans("IsWorkflowEnable")}
                      inputName={"IsWorkflowEnable"} />
                    </div>
                    <div>
                    <CheckableButton 
                    type="checkbox"
                    mode={mode}
                    defaultChecked={obj?.HasSignature
                    }
                     defaultValue={obj?.HasSignature
                     } 
                     labelText={trans("HasSignatureForm")}
                      inputName={"HasSignature"} />
                    </div>
                    </>
                    :<></>}
                    <div className="col-lg-12 mt-1 btns_form">
                        {mode!="view"?
                        <>
                        <Button btnType="submit" value="Save" />
                        <Button btnType="cancel" value="cancel" onClick={()=>{cancel()}} />
                        </>:
                        <Button btnType="primary" value="close" onClick={()=>{cancel()}} />
                        }
                    </div>
                </div>
            </div>
        </form>
     );
}
